import styled from 'styled-components';

export const BannerContainer = styled.div`
  margin: ${(props) => (props.lactoMama ? '0' : '0 0 16px')};
  position: relative;
  padding-top: ${(props) => (props.firstImage ? '37%' : 'initial')};
`;

export const BannerImage = styled.img`
  width: 100%;
  height: 100%;
  display: block;
  position: ${(props) => (props.firstImage ? 'absolute' : 'static')};
  top: 0;
`;
